// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pq-0";